module.exports = __webpack_public_path__ + "static/img/data.df6e34c5.png";